import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces/index';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  return {
    helper: {
      marginTop: '20px',

      [breakpoints.down(ScreenSizes.Tablet)]: {
        marginTop: '10px',
      },
    },
    helperTitle: {
      fontWeight: 'bold',
      fontSize: '14px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        fontSize: '12px',
      },
    },
    helperText: {
      fontSize: '14px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        fontSize: '12px',
      },
    },
  };
};
